import { useEffect } from 'react'
import { useUser } from '../dataHooks'
import sleep from '../utils/sleep'

function SleekWidget({ id }) {
  const { user } = useUser()

  useEffect(() => {
    if (document?.getElementById('sleek-script-src')) return
    window.SLEEK_PRODUCT_ID = id
    window.$sleek = []
    ;(() => {
      const d = document
      const s = d.createElement('script')
      s.src = 'https://client.sleekplan.com/sdk/e.js'
      s.async = 1
      s.id = 'sleek-script-src'
      d.getElementsByTagName('body')[0].appendChild(s)
    })()

    // window.document.addEventListener('sleek:open', callback, false)
    // window?.$sleek?.hideButton()
  }, [])

  useEffect(() => {
    const handleSetUser = async () => {
      await sleep(3000)
      if (user?._id && window?.$sleek?.setUser) {
        window.$sleek.setUser({
          mail: user.email,
          id: user._id,
          name: user.name,
          img: user.image,
        })
      }
    }
    handleSetUser().catch(err => {
      console.log(err)
    })
  }, [user])

  return null
}

export default SleekWidget
